<template>
    <div class="min-h-screen bg-gray-100 dark:bg-slate-900">
        <div class="flex flex-col min-h-screen">
            <header class="bg-white dark:bg-slate-800 shadow dark:shadow-slate-900/50">
                <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <div class="flex justify-between items-center">
                        <Link href="/" class="flex items-center">
                            <img
                                src="/images/logo.svg"
                                alt="My10x Logo"
                                class="h-8 w-auto"
                            />
                            <span
                                class="ml-2 text-xl font-semibold text-gray-800 dark:text-gray-100 sr-only"
                            >
                                My10x
                            </span>
                        </Link>
                        <div class="flex space-x-4">
                            <Link
                                href="/login"
                                class="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100"
                            >
                                Login
                            </Link>
                            <Link
                                href="/register"
                                class="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100"
                            >
                                Register
                            </Link>
                        </div>
                    </div>
                </div>
            </header>

            <main class="grow">
                <slot />
            </main>

            <footer class="bg-white dark:bg-slate-800 shadow dark:shadow-slate-900/50 mt-auto">
                <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <div class="flex justify-between items-center">
                        <div class="text-sm text-gray-500 dark:text-gray-400">
                            &copy; {{ new Date().getFullYear() }} My10x. All
                            rights reserved.
                        </div>
                        <div class="flex space-x-4 text-sm text-gray-500 dark:text-gray-400">
                            <Link
                                href="/privacy-policy"
                                class="hover:text-gray-900 dark:hover:text-gray-100"
                            >
                                Privacy Policy
                            </Link>
                            <Link
                                href="/terms-of-use"
                                class="hover:text-gray-900 dark:hover:text-gray-100"
                            >
                                Terms of Use
                            </Link>
                            <Link href="/faq" class="hover:text-gray-900 dark:hover:text-gray-100">
                                FAQs
                            </Link>
                            <Link href="/security" class="hover:text-gray-900 dark:hover:text-gray-100">
                                Security
                            </Link>
                            <Link href="/support" class="hover:text-gray-900 dark:hover:text-gray-100">
                                Support
                            </Link>
                            <Link href="/changelog" class="hover:text-gray-900 dark:hover:text-gray-100">
                                Changelog
                            </Link>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    </div>
</template>

<script setup>
import { Link } from '@inertiajs/vue3';
</script>
